<template>
  <v-row class="my-16">
    <v-col v-for="item in this.hint.banners" cols="12" xl="3" lg="3" md="3" class="text-center d-flex justify-center align-start">
      <div class="test d-flex flex-column justify-center align-center mx-6">
        <v-img class="mb-4" contain height="100" width="120" :src="item.file"></v-img>
<!--        <v-icon size="90" color="#FCC300" class="mb-4">{{item.file}}</v-icon>-->
        <h4 class="font-weight-bold">{{item.title}}</h4>
        <p>{{item.details}}</p>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'CompanyHint',

  computed: {
    ...mapState({
      hint: state => state.homeManagement.hint,
    })
  },
}
</script>
<style scoped>
.test{
  position: relative;
  animation-name: examples;
  animation-duration: 3s;
  animation-fill-mode: forwards;
}
@keyframes examples {
  from {top: 300px;}
  to {top:0;}
}
</style>